import { render, staticRenderFns } from "./DataViewerModal.yaml?vue&type=template&id=502f744c&component"
import script from "./DataViewerModal.yaml?vue&type=script&lang=ts&component"
export * from "./DataViewerModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports